module.exports = __webpack_public_path__ + "img/battery.35630acf.svg";